
import React, {useContext, useState} from 'react';

import {Button, Card, CardContent, CardMedia, Chip, Container, ListItem, Paper, Box} from "@mui/material";
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";

import MusicNoteIcon from "@mui/icons-material/MusicNote";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import EventIcon from "@mui/icons-material/Event";
import GroupIcon from "@mui/icons-material/Group";
import InventoryIcon from "@mui/icons-material/Inventory";
import DescriptionIcon from "@mui/icons-material/Description";
import ChecklistIcon from "@mui/icons-material/Checklist";
import MailIcon from "@mui/icons-material/Mail";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ListItemText from "@mui/material/ListItemText";
import dayjs from "dayjs";
import {PAContext} from "../../../Services/PAContext";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";

import GetPlanningImage from '../../../graphics/Gemini_Generated_Image_rvchbfrvchbfrvch.jpg';
import SunsetImage from '../../../graphics/Gemini_Generated_Image_smehshsmehshsmeh.jpg';
import GetItAllTogetherImage from '../../../graphics/Gemini_Generated_Image_mp391jmp391jmp39.jpg';


function Overview(props) {

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, setAccount, setPlanningBudget, setPlanningBudgetCurrency } = useContext(PAContext);
    const { Account, authenticated } = dataArray;


    const [lookingAt, setLookingAt] = useState('overview');
    const [zoomInOn, setZoomInOn] = useState({});


    const upcomingHolidays = [
        { name: "Memorial Day", date: "2025-05-26" },
        { name: "Independence Day", date: "2025-07-04" },
        { name: "Labor Day", date: "2025-09-01" }
    ];

    const CalendarView = ({ holidays }) => (
        <List dense>
            {holidays.map((holiday, index) => (
                <ListItem key={index}>
                    <ListItemIcon>
                        <CalendarTodayIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary={holiday.name}
                        secondary={dayjs(holiday.date).format('dddd, MMM D')}
                    />
                </ListItem>
            ))}
        </List>
    );
    const UpcomingEventsList = ({ events }) => {
        if (!events || events.length === 0) {
            return <Typography variant="body2" color="text.secondary">No upcoming events.</Typography>;
        }

        return (
            <List dense>
                {events.map((event, index) => (
                    <ListItem key={index}>
                        <ListItemText
                            primary={event.title}
                            secondary={`${dayjs(event.date).format('MMM D')} @ ${event.title}`}
                        />
                    </ListItem>
                ))}
            </List>
        );
    };

    const getChipStyle = (label) => {
        const styles = {
            Flights: { bgcolor: '#e3f2fd', color: '#1976d2' },
            Lodging: { bgcolor: '#f3e5f5', color: '#9c27b0' },
            Meals: { bgcolor: '#fce4ec', color: '#d81b60' },
            Activities: { bgcolor: '#fff3e0', color: '#fb8c00' },
            Attendees: { bgcolor: '#e8f5e9', color: '#43a047' },
            Supplies: { bgcolor: '#ede7f6', color: '#5e35b1' },
            Documents: { bgcolor: '#e0f7fa', color: '#00838f' },
            'To Do': { bgcolor: '#fffde7', color: '#f9a825' },
            RSVP: { bgcolor: '#fce4ec', color: '#c2185b' },
            Weather: { bgcolor: '#e1f5fe', color: '#039be5' },
            Reminders: { bgcolor: '#f3e5f5', color: '#8e24aa' },
            Itinerary: { bgcolor: '#e8eaf6', color: '#3949ab' },
            Photos: { bgcolor: '#f1f8e9', color: '#7cb342' },
            Messages: { bgcolor: '#e0f2f1', color: '#00796b' },
            Ideas: { bgcolor: '#fff8e1', color: '#fbc02d' },
            'Business Expenses': { bgcolor: '#fbe9e7', color: '#e64a19' },
        };

        return styles[label] || {};
    };




    return (

        <Container
            sx={{
                maxWidth: '100vw !important',
                padding: '0 !important'
            }}
        >

            <Box sx={{ bgcolor: '#fafafa', paddingBottom: 4 }}>
                <Card sx={{ borderRadius: 0 }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={GetPlanningImage}
                        alt="Event Hero"
                    />
                    <CardContent>
                        <Typography variant="h5" fontWeight="bold">
                            🎉 Plan something exciting!
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button variant="contained" color="primary" sx={{ flex: 1 }}>
                                Jump right in
                            </Button>
                            <Button variant="contained" color="primary" sx={{ flex: 1 }}>
                                Start with a Template
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>

            <Box sx={{ bgcolor: '#fafafa', paddingBottom: 4 }}>
                <Card sx={{ borderRadius: 0 }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={SunsetImage}
                        alt="Event Hero"
                    />
                    <CardContent>
                        <Typography variant="h5" fontWeight="bold">
                            🎉 A little Head Start!
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="secondary" />
                                    <Typography variant="body2" mt={1}>Memorial Day</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="primary" />
                                    <Typography variant="body2" mt={1}>Independence Day</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="success" />
                                    <Typography variant="body2" mt={1}>Labor Day</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="error" />
                                    <Typography variant="body2" mt={1}>Halloween</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="warning" />
                                    <Typography variant="body2" mt={1}>Thanksgiving</Typography>
                                </Paper>
                            </Grid>

                            <Grid item xs={6}>
                                <Paper sx={{ padding: 2, textAlign: 'center' }}>
                                    <MusicNoteIcon fontSize="large" color="info" />
                                    <Typography variant="body2" mt={1}>New Year’s Day</Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>

            <Box sx={{ bgcolor: '#fafafa', paddingBottom: 4 }}>
                <Card sx={{ borderRadius: 0 }}>
                    <CardMedia
                        component="img"
                        height="200"
                        image={GetItAllTogetherImage}
                        alt="Event Hero"
                    />
                    <CardContent>
                        <Typography variant="h5" fontWeight="bold">
                            🎉 Get It All Together
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1,
                            }}
                        >
                            <Chip icon={<FlightIcon />} label="Flights" sx={getChipStyle('Flights')} />
                            <Chip icon={<HotelIcon />} label="Lodging" sx={getChipStyle('Lodging')} />
                            <Chip icon={<RestaurantIcon />} label="Meals" sx={getChipStyle('Meals')} />
                            <Chip icon={<EventIcon />} label="Activities" sx={getChipStyle('Activities')} />
                            <Chip icon={<GroupIcon />} label="Attendees" sx={getChipStyle('Attendees')} />
                            <Chip icon={<InventoryIcon />} label="Supplies" sx={getChipStyle('Supplies')} />
                            <Chip icon={<DescriptionIcon />} label="Documents" sx={getChipStyle('Documents')} />
                            <Chip icon={<ChecklistIcon />} label="To Do" sx={getChipStyle('To Do')} />
                            <Chip icon={<MailIcon />} label="RSVP" sx={getChipStyle('RSVP')} />
                            <Chip icon={<WbSunnyIcon />} label="Weather" sx={getChipStyle('Weather')} />
                            <Chip icon={<NotificationsIcon />} label="Reminders" sx={getChipStyle('Reminders')} />
                            <Chip icon={<AccessTimeIcon />} label="Itinerary" sx={getChipStyle('Itinerary')} />
                            <Chip icon={<PhotoCameraIcon />} label="Photos" sx={getChipStyle('Photos')} />
                            <Chip icon={<ChatBubbleIcon />} label="Messages" sx={getChipStyle('Messages')} />
                            <Chip icon={<LightbulbIcon />} label="Ideas" sx={getChipStyle('Ideas')} />
                            <Chip icon={<MonetizationOnIcon />} label="Business Expenses" sx={getChipStyle('Business Expenses')} />

                        </Box>
                    </CardContent>
                </Card>
            </Box>


            {/* this is the splash screen before anything is selected */}
            {
                dataArray.authenticated ? (
                    <>
                        {/* Logged in section */}
                        <Typography variant="h6" fontWeight="bold" mt={4}>
                            📅 Your Upcoming Events
                        </Typography>


                        <Typography variant="h6" fontWeight="bold" mt={3}>
                            ✅ To-Do Items
                        </Typography>

                    </>
                ) : (
                    <Box sx={{ bgcolor: '#fafafa', paddingBottom: 4 }}>
                        <Card sx={{ borderRadius: 0 }}>
                            <CardMedia
                                component="img"
                                height="200"
                                image={GetItAllTogetherImage}
                                alt="Event Hero"
                            />
                            <CardContent>
                                <Typography variant="h5" fontWeight="bold">
                                    🎉 Get It All Together
                                </Typography>

                            </CardContent>
                        </Card>
                    </Box>

                )
            }

        </Container>

    )

}

export default Overview;
